import React, { FC, useState } from 'react';
import { Event } from '../../Interfaces/Event';
import formValidation from '../../Pages/AddAddress/formValidation';
import states from '../../utils/states';
import Dropdown from './Dropdown';
import Error from './Error';
import styles from './Input.module.scss';

interface Props {
  label: string,
  type: string,
  enableDropdown?: boolean,
  name: string,
  error?: string,
  value?: string,
  required?: boolean,
  // eslint-disable-next-line no-unused-vars
  onChange: (e: Event) => void,
  // eslint-disable-next-line no-unused-vars
  handleError: (err: any) => void,
}
const Input: FC<Props> = ({
  label, type, enableDropdown, name, onChange, value, handleError, required = true,
}) => {
  const {
    fieldValidation, phoneValidation, pinValidation, emailValidation,
  } = formValidation;
  const [error, setError] = useState();
  const handleBlur = (e: { target: any }) => {
    let err: any;
    if (!required) return;
    if (type === 'email') err = emailValidation(e.target.value);
    else if (name === 'phone') err = phoneValidation(e.target.value);
    else if (name === 'pin') err = pinValidation(e.target.value);
    else { err = fieldValidation(type, e.target.value); }
    setError(err);
    handleError(err);
  };

  return (
    <div className={styles.inputContainer}>
      <div className={styles.label}>
        {label}
        {required && <span>*</span>}
      </div>
      {enableDropdown
        ? <Dropdown list={states} fieldName={name} onChange={onChange} /> : (
          <>
            <input
              type={type}
              className={`${styles.input} ${error && styles.inputError}`}
              name={name}
              onChange={onChange}
              onBlur={handleBlur}
              value={value}
            />
            <Error error={error} />
          </>
        )}
    </div>
  );
};

export default Input;
